<template>
    <div class="page">
        <div class="userinfo-wrap">
            <div class="flex-group flex-center">
                <div class="avatar"></div>
                <div class="account yellow">{{userInfo.name || userInfo.uuid}} <span @click="goto('info')">[edit]</span></div>
            </div>
            <div class="flex-group flex-between">
                <div class="month-rank">{{userInfo.ranking}}</div>
                <!--<div class="quarter-rank">{{userInfo.ranking_quarter}}</div>-->
                <div class="score-wrap yellow">
                    <img class="s-icon" src="~@/assets/s-icon.png" alt=""> {{userInfo.score}}
                </div>
            </div>
        </div>
        <div class="menu-wrap">
            <div class="menu-item" @click="goto('contentlist')"></div>
            <div class="menu-item" @click="goto('myqs')">
                <em class="question-count"> {{userInfo.question_count}}</em>
            </div>
            <div class="menu-item" @click="goto('rank')"></div>
            <div class="menu-item" @click="goto('setting')"></div>
        </div>
        <div class="fs30 txtcenter" style="font-weight: 700;margin-top:1.2rem;font-size:.35rem;" @click="goto('Privacy/Policy')">Privacy Policy >></div>
      <!--  <div class="score-wrap yellow" >
            <img class="s-icon" style="width: 100%" src="~@/assets/banner.png" alt="" @click="goto('activity')">
        </div>-->
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Ucenter',
    data(){
        return {
            id: '',
            name: '',
            mobile: '',
            score: 0,
            ranking: 0,
            list: [],

            showSharePop: false,
            shareTitle: '',
            shareDesc: '',
            questionId: this.$route.query.id
        }
    },
    computed: {
        ...mapState(['userInfo','lang','langMap'])
    },
    created(){
        //console.log(localStorage.A_mobile);
        if(typeof this.$route.query.mobile != 'undefined' &&
            typeof this.$route.query.sign != 'undefined'){
          /*  console.log(typeof this.$route.query.mobile);
            console.log(typeof this.$route.query.sign);*/
            this._fetchCookiesInfo();
        }else{
           this._fetchInfo();
        }
    },
    methods: {
        ...mapActions(['setUserInfo']),
        _fetchInfo(){
            let that = this;
            Utils.$ajax({
                url: '/user/info',
                type: 'post',
                data: {}
            }).done(res =>{
                this.loaded = true;
                if (res.code != 0){
                    console.log(res.msg);
                    this.$dialog({
                        message: res.msg,
                        confirmButtonText: 'OK'
                    }).then(action=>{
                        localStorage.removeItem('localUuid');
                        localStorage.removeItem('localToken');
                        this.$router.push('/login');
                    })
                } else if (res.code == 0 && res.data.status == 2){
                    let msg = "Your balance is insufficient, please try again after recharge";
                    this.$dialog({
                        message: msg,
                        confirmButtonText: 'OK'
                    }).then(action=>{

                    })
                }else {
                    this.setUserInfo(res.data);
                }

            })
        },
        _fetchCookiesInfo(){
            let that = this;
            let reqData = {
                mobile: this.$route.query.mobile,
                sign: this.$route.query.sign,
            };
            Utils.$ajax({
                type: 'post',
                url: '/login/fast',
                data: reqData,
            }).done(res=>{
                   if(res.code==0){
                        this.setUserInfo(res.data);
                        localStorage.localUuid = res.data.uuid;
                        localStorage.localToken = res.data.token;
                        localStorage.localMisisdn = res.data.mobile;
                        this.$router.push('/Ucenter');
                    }else{
                        localStorage.removeItem('localUuid');
                        localStorage.removeItem('localToken');
                        //this.$router.push('/Welcome');
                    }
            })
        },
        goto(page){
            this.$router.push(page);
        }
    }
}
</script>

<style lang="scss" scoped>
    .userinfo-wrap{
        margin: 0 auto;
        width: rem(693);
        height: rem(288);
        padding: rem(50) rem(60) rem(60);
        background: url('~@/assets/u-bg.png') no-repeat;
        background-size: contain;
        .avatar{
            width: rem(117);
            height:rem(117);
            background: url(~@/assets/u-icon.png) 0 0 no-repeat;
            background-size: contain;
            border-radius: 50%;
            border: 2px #fff solid;
        }
        .account{
            margin-left: rem(30);
        }
        .score-wrap{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .s-icon{
                width: rem(52);
                height: rem(52);
                margin-right: 3px;
            }
        }
        .month-rank{
            width: rem(181);
            height: rem(72);
            background: url(~@/assets/rank-bg-1.png) no-repeat center center /contain;
            padding-left: rem(90);
            line-height: rem(80);
            color: #ffff66;
            font-weight: bold;
        }
        .quarter-rank{
            width: rem(203);
            height: rem(84);
            background: url(~@/assets/rank-bg-2.png) no-repeat center center /contain;
            color: #fff;
            font-weight: bold;
            padding-left: rem(90);
            line-height: rem(88);
        }
    }

    .menu-wrap{
        display: flex;
        width: rem(728);
        height: rem(538);
        margin:rem(70) auto 0;
        background: url('~@/assets/menu.png') center center/contain no-repeat;
        justify-content: space-between;
        flex-wrap: wrap;
        .menu-item{
            position: relative;
            width: rem(363);
            height: rem(228);
            margin-bottom: rem(70);
        }
        .question-count{
            position: absolute;
            color: #fff;
            font-size: rem(28);
            left: rem(179);
            top: rem(178);
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Ucenter.vue